module.exports = __webpack_public_path__ + "img/act-of-emotion-process-1-mobile.7244f1db.jpg";